export enum ObjectType {
    Tag,
    Identifier,
    Undefined,
    HistorianTag
}

export enum GuidObjectType {
    Undefined,
    Tag,
    Identifier,
    Group,
    ConnectionPoint,
    Application,
    Dashboard
}